import React, { useEffect } from "react";
import { withFormik } from "formik";
import "./Login.css";
import LoginForm from "../../components/LoginForm";
import { authorize, showErrorToast } from "../../helpers";
import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";

const Login = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchParams.has('google_oauth_tokens_response')) {
      const oauthTokensResponseEncoded = searchParams.get('google_oauth_tokens_response');

      navigate({
        pathname: "/sso-auth",
        search: createSearchParams({
          google_oauth_tokens_response: oauthTokensResponseEncoded
        }).toString()
      });
    } else if (searchParams.has('microsoft_oauth_tokens_response')) {
      const oauthTokensResponseEncoded = searchParams.get('microsoft_oauth_tokens_response');

      navigate({
        pathname: "/sso-auth",
        search: createSearchParams({
          microsoft_oauth_tokens_response: oauthTokensResponseEncoded
        }).toString()
      });
    }

  }, [])

  return (
    <div className="container form_wrapper d-flex justify-content-center">
      <LoginForm {...props} />
    </div>
  );
};

const mapPropsToValues = () => ({
  username: "",
  password: "",
});

const hasEnabledTab = tabs => Object.values(tabs || {}).some(Boolean);

const handleSubmit = async (value, { props }) => {
  try {
    const auth = await authorize({
      ...value,
      username: value.username.trim().toLowerCase(),
    });
    const { tabConfig } = await props.login(auth);

    if (!hasEnabledTab(tabConfig)) {
      showErrorToast("No permitted services");
      return;
    }

    props.navigate("/screened-manuscripts");
  } catch (error) {
    console.error(error);
    if (error.response?.status === 401) {
      showErrorToast("Not authorized");
    } else {
      showErrorToast("Error, something went wrong");
    }
  }
};

export default withFormik({ handleSubmit, mapPropsToValues })(Login);
